export default () => {
	function cerrarCompartir(){
		$("div.cont-panel-rs").removeAttr("style");
		$("button.button-rs-desp .fa-ellipsis-v").removeClass("fa-ellipsis-v").addClass("fa-ellipsis-h");
		$("button.button-rs-desp .fa-times").removeClass("fa-times").addClass("fa-share-alt");
    }
	function cerrarReportar(){
		$("span.edi-report .button-rs.bg-report.active").removeClass("active");
    }
	function cerrarGuardar(){
		$("button.button-rs.bg-save.active").removeClass("active");
    }
	$("button.button-rs-desp").off('click').click(function() {
		cerrarReportar();
		cerrarGuardar();
	});
	$("span.edi-report span.button-rs.bg-report").off('click').click(function() {
		cerrarCompartir();
		cerrarGuardar();
	});
	$("button.button-rs.bg-save").off('click').click(function() {
		cerrarCompartir();
		cerrarReportar();
	});
}
